import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Auth from '../../pages/private/js/Auth';
import Home from '../../pages/private/js/Home';
import FutureEvents from '../../pages/private/js/FutureEvents';
import PastEvents from '../../pages/private/js/PastEvents';
import CreateEvent from '../../pages/private/js/CreateEvent';
import PrivateEvent from '../../pages/private/js/PrivateEvent';
import WithdrawalEvents from '../../pages/private/js/WithdrawalEvents';
import WithdrawalEvent from '../../pages/private/js/WithdrawalEvent';
import Event from '../../pages/private/js/Event'
import SetPassword from '../../pages/private/js/SetPassword';

const PrivateRoutes = () => (
  <Routes>
    <Route path="/admin/dashboard" element={<Auth><Home /></Auth>} />
    <Route path="/admin/events/future" element={<Auth><FutureEvents /></Auth>} />
    <Route path="/admin/events/past" element={<Auth><PastEvents /></Auth>} />
    <Route path="/admin/events/new" element={<Auth><CreateEvent /></Auth>} />
    <Route path="/admin/event" element={<Auth><Event /></Auth>} />
    <Route path="/admin/private-event" element={<Auth><PrivateEvent /></Auth>} />
    <Route path="/admin/withdrawal" element={<Auth><WithdrawalEvents /></Auth>} />
    <Route path="/admin/withdrawal/event" element={<Auth><WithdrawalEvent /></Auth>} />

    <Route path="/admin/set-password" element={<SetPassword />} />
  </Routes>
);

export default PrivateRoutes;
